module.exports = __webpack_public_path__ + "media/dashboard/assets/images/berrysupport-onboard-livechat-c2340ae3dae1a78bc839a117095e2cca.svg";